/**
 * Save a file from a signed URL without opening a new tab.
 *
 * The URL must already carry a Content-Disposition: attachment response (R2
 * getDownloadUrl, or a Supabase signed URL created with { download }). The `download`
 * attribute alone is ignored for cross-origin URLs, so the header is what forces the
 * save; the hidden anchor just avoids the blank tab and pop-up blocker that
 * window.open() brings (ENG-109). Same pattern as ClientDocuments' openNative().
 */
export function triggerDownload(url: string, fileName?: string): void {
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName ?? "";
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
